export default {
    'stopautism.ru'
:
    'https://stopautism.ru/',
        'autisticCity'
:
    'https://aspergers.ru/',
        'autism-aba'
:
    'https://autism-aba.blogspot.com/',
        'aba-kurs'
:
    'https://aba-kurs.com/',
        'HappyABA'
:
    'https://happyaba.ru/',
        'aba-samara.ru'
:
    'http://aba-samara.ru/',
        'proaba.ru'
:
    'https://proaba.ru/',
        'proautism'
:
    'https://proautism.ru/',
        'moaplaneta.com'
:
    'https://moaplaneta.com/',
        'аутизм-урал'
:
    'https://аутизм-урал.рф/',
        'psylab.info'
:
    'https://psylab.info/Главная_страница',
        'РОО «Дети - наше счастье»'
:
    'https://roodns.tilda.ws/',
        'АНО «Мир возможностей»,  г. Новокузнецк'
:
    'http://мир-возможностей.рф/',
        'АНО «Дети света», г. Уфа'
:
    'https://vk.com/public215275616',
        'РБОО «Будь всегда рядом»'
:
    'https://vk.com/bvr_ufa',
        'РООИ «Перспектива»'
:
    'https://perspektiva-inva.ru/',
        'Ассоциация «Спектр», г. Новосибирск'
:
    'https://spectrnsk.ru/',
        '"Синяя птица", г. Белогорск'
:
    'https://vk.com/c.sptica',
        'АНО «Город радуги»'
:
    'https://vk.com/gorod_radugi_slv',
        'АНО «Сияние чистого разума»'
:
    'https://сияниечистогоразума.рф/',
        'АНО «Дети-наше счастье»'
:
    'https://deti-nasheschastie-str.vsite.pro/',
        'РРЦ РАС РБ'
:
    'https://autismrcrb.02edu.ru/',
        'Центр ментального здоровья'
:
    'https://vk.com/rkpb_mental_health',
        'АНО «РАСсвет»'
:
    'https://autism-ufa.ru/',
        'РОО РБ «СоДействие»'
:
    'https://roosd.ru/',
        'АНО «Наш солнечный мир»'
:
    'https://solnechnymir.ru/',
        'Образовательный фонд «Мархамат»'
:
    'https://fond-marhamat.ru/',
        'Общественный центр «Улей», Уфа'
:
    'https://uley.sosedi.app/',
        '«Академия успеха», Уфа'
:
    'https://ak-uspeha.ru/',
        'ФРЦ РАС'
:
    'https://autism-frc.ru/',
        'ФРЦ ОВЗ'
:
    'https://ikp-rao.ru/frc-ovz/',
        'ФРЦ ТМНР'
:
    'http://frc-tmnr.pskov.ru/',
        'Центр лечебной педагогики'
:
    'https://ccp.org.ru/',
        'Аутизм-регионы'
:
    'https://autismregions.ru/',
        'Фонд «Выход»'
:
    'https://outfund.ru/',
        'Центр «Обнаженные сердца»'
:
    'https://nakedheart.center/',
        'Территория речи'
:
    'http://speech-area.ru/'
}